/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import { useMutation } from '@apollo/client';
import { useHistory } from 'react-router-dom';
import TextInput from '../../../../components/input';
import SelectSearch from '../../../../components/SelectSearch';
import { GET_INSTITUTION_DETAILS } from '../../../../graphql/admin_queries';
import useCustomQuery from '../../../../network/useCustomQuery';
import { toTitleCase } from '../../../../utils/helpers';
import StyledButton from '../../../../components/StyledButton';
import { UPDATE_USER_PROFILE } from '../../../../graphql/admin_mutations';
import '../PersonalInfoEdit/PersonalInfoEdit.scss';
import useForm from '../../../../customHooks/useForm';
import useToast from '../../../../customHooks/useToast';
import Dots from '../../../../components/Loading/Dots';

const findChangeBetweenObjects = (oldObject: any, newObject: any) => {
  let hasChanged = false;
  Object.keys(newObject).forEach((key) => {
    if (oldObject[key] !== newObject[key]) {
      hasChanged = true;
    }
  });
  return hasChanged;
};
interface IInstitutionDetailEdit{
  payload:any;
  buttonState?:boolean;
  disableMode?: boolean
  customerId?:any;
  fetchCustomer?: any;
}
const InstitutionDetailEdit = ({
  payload, buttonState, customerId, disableMode, fetchCustomer,
}:IInstitutionDetailEdit) => {
  const [getInstitutions, , institutionDetails] = useCustomQuery({
    query: GET_INSTITUTION_DETAILS,
    onError: () => {},
    onData: () => {},
  });
  const Toast = useToast();
  const [institutions, setInstitutions] = useState([]);
  const [institutionsData, setInstitutionsData] = useState(null);
  const [campus, setCampus]: any = useState([]);
  const [questions, setQuestions]: any = useState([]);
  const [degrees, setDegrees]: any = useState([]);
  const [campusCity, setCampusCity]: any = useState([]);
  const [loading, setLoading] = useState(false);
  const [institutionProvince, setInstitutionProvince]: any = useState([]);
  const isAllowUpdate = payload?.hasProfileUpdateRequest;
  const history = useHistory();

  const {
    formValues,
    handleChange,
    resetForm,
  } = useForm(
    {
      institution_name: '',
      campus: '',
      degree: '',
      flight_question: '',
      flight_answer: '',
      isPGWPEligible: '',
      institution_city: '',
      institution_province: '',
      otherProgramme: '',
      student: '',
      nationality: '',
    },
  );

  const [updateUserProfile, { loading: updateUserProfileLoading }] = useMutation<
  { adminUpdateUserProfileCa: any },
  any
>(UPDATE_USER_PROFILE);

  const getIntitutionInfo = ({ institutionData, institutionName, city }: any) => {
    const cities: any = [];
    const campuses: any = [];
    const degrees: any = [];
    const questions: any = [];
    let PGWPEligible: boolean = false;

    if (institutionName) {
      institutionData[institutionName]?.cities?.forEach?.((data: any) => {
        cities.push({
          label: data?.city,
          value: data?.city,
        });
        if (city && city === data?.city) {
          data?.campuses?.forEach?.((campus: any) => {
            campuses.push({
              label: campus,
              value: campus,
            });
          });
          data?.degrees?.forEach?.((degree: any) => {
            degrees.push({
              label: degree,
              value: degree,
            });
          });
          data?.questions?.forEach?.((question: any) => {
            questions.push({
              label: question,
              value: question,
            });
          });
          PGWPEligible = !!data?.isEligible;
        }
      });
    }
    return {
      cities,
      campuses,
      degrees,
      questions,
      PGWPEligible,
    };
  };

  const handleSubmit = async () => {
    const institution = {
      institution_province: formValues?.institution_province,
      institution_name: formValues?.institution_name,
      institution_city: formValues?.institution_city,
      campus: formValues?.campus,
      degree: formValues?.degree === 'Others' ? formValues?.otherProgramme : formValues?.degree,
      flight_question: formValues?.flight_question,
      flight_answer: formValues?.flight_answer,
      isPGWPEligible: formValues?.isPGWPEligible,
      degreeType: formValues?.degree === 'Others' ? 'Others' : '',
    };

    const variables = {
      ...(payload?.userRtDetail.enrolled_as_student && { institution }),
      userId: customerId,
    };

    if (!updateUserProfileLoading) {
      try {
        const res = await updateUserProfile({
          variables,
        });

        if (res?.data?.adminUpdateUserProfileCa?.status === 200) {
          fetchCustomer();

          Toast.success(res?.data?.adminUpdateUserProfileCa?.message || 'Operation successful');
        } else {
          Toast.error(res?.data?.adminUpdateUserProfileCa?.message || 'Operation Failed');
        }
      } catch (e: any) {
        if (e && e.graphQLErrors && e.graphQLErrors.length > 0) {
          Toast.error(e.graphQLErrors[0].message);
        } else {
          Toast.error('Something went wrong');
        }
      }
    }
  };

  const getInstitutionsApi = async () => {
    setLoading(true);
    await getInstitutions();
    setLoading(false);
  };

  const oldValues = {
    institution_name: payload?.userRtDetail?.institution_name,
    campus: payload?.userRtDetail?.campus,
    degree: payload?.userRtDetail?.degree,
    flight_question: payload?.userRtDetail?.flight_question,
    flight_answer: payload?.userRtDetail?.flight_answer,
    isPGWPEligible: payload?.userRtDetail?.isPGWPEligible ? 'Yes' : 'No',
    institution_city: payload?.userRtDetail?.institution_city,
    institution_province: payload?.userRtDetail?.institution_province,
    otherProgramme: '',
    student: payload?.userRtDetail?.enrollment_type === 'student' ? 'Yes' : 'No',
    nationality: payload?.userRtDetail?.nationality,
  };

  useEffect(() => {
    if (institutionDetails?.getInstutionDetails?.data) {
      const provinces = Object?.keys(institutionDetails?.getInstutionDetails?.data)?.map(
        (provinceName) => ({
          label: toTitleCase(provinceName),
          value: provinceName,
        }),
      );
      setInstitutionProvince(provinces);
      setInstitutionsData(institutionDetails?.getInstutionDetails?.data);
      const institutionsObj: any = {};
      Object?.keys(institutionDetails?.getInstutionDetails?.data)?.forEach((province: string) => {
        const institutionsArray: any = [];
        const instData = institutionDetails?.getInstutionDetails?.data[province];
        Object?.keys(instData)?.forEach((key) => {
          const distructureData = {
            ...instData[key],
            label: instData[key]?.name,
            value: instData[key]?.name,
          };
          institutionsArray.push(distructureData);
        });
        institutionsObj[province] = institutionsArray;
      });

      setInstitutions(institutionsObj);
    }
  }, [institutionDetails]);

  useEffect(() => {
    getInstitutionsApi();
  }, []);

  useEffect(() => {
    if (payload?.userRtDetail?.institution_province) {
      resetForm({
        ...oldValues,
      });
    }
  }, [payload?.userRtDetail]);

  useEffect(() => {
    if (
      institutionsData
      && formValues?.institution_name
      && formValues?.institution_province
    ) {
      const {
        cities: campusCityArray,
        campuses: campusArray,
        degrees: degreeArray,
        questions: questionsArray,
        PGWPEligible,
      } = getIntitutionInfo({
        institutionData: institutionsData[formValues?.institution_province],
        institutionName: formValues?.institution_name,
        city: formValues?.institution_city,
      });

      setCampusCity(campusCityArray);
      setCampus(campusArray);
      setDegrees(degreeArray);

      setQuestions(questionsArray);

      resetForm({ isPGWPEligible: PGWPEligible ? 'Yes' : 'No' });

      // TODO: Set campus value, degree value and questions value to the first element of the array if  the array has just one element
      if (campusArray?.length === 1) {
        resetForm({ campus: campusArray[0]?.value });
      }
      if (degreeArray?.length === 1) {
        resetForm({ degree: degreeArray[0]?.value });
      }

      if (questionsArray?.length === 1) {
        resetForm({ flight_question: questionsArray[0]?.value });
      }
    }
  }, [
    formValues.institution_name,
    formValues.institution_city,
    institutionsData,
    formValues.degree,
    formValues?.institution_province,
  ]);

  const fullName = `${payload?.firstName} ${payload?.lastName}`;

  const inputChangeDetected = findChangeBetweenObjects(oldValues, formValues);
  const allDetailsSelected = formValues?.institution_province && formValues?.institution_name && formValues?.institution_city && formValues?.campus;

  return (
    <div className="edit-wrapper">
      <div className="edit-details">
        <div className="edit-wrapper-text">
          Institution Details of
          {' '}
          {fullName}
        </div>
        {loading
          ? (
            <div className="profile-edit-loader">
              <Dots />
            </div>
          ) : (
            <>
              <div className="row">
                <div className="col-md-6 col-12" style={{ marginBottom: '24px' }}>
                  <SelectSearch
                    options={institutionProvince}
                    disabled={buttonState || disableMode}
                    placeholder="Institution Province"
                    name="institution_province"
                    value={formValues?.institution_province}
                    onChange={(event: any) => {
                      resetForm({
                        institution_province: event?.target?.value,
                        institution_name: '',
                      });
                    }}
                  />
                </div>
                <div className="col-md-6 col-12" style={{ marginBottom: '24px' }}>

                  <SelectSearch
                    options={institutions[formValues?.institution_province]}
                    disabled={buttonState || disableMode}
                    placeholder="Institution Name"
                    // label="Institution Name"
                    name="institution_name"
                    value={formValues?.institution_name}
                    onChange={(event: any) => {
                      resetForm({
                        flight_question: '',
                        flight_answer: '',
                        campus: '',
                        institution_name: event?.target?.value,
                        isPGWPEligible: '',
                        degree: '',
                        institution_city: '',
                      });
                    }}
                  />

                </div>
                <div className="col-md-6 col-12" style={{ marginBottom: '24px' }}>

                  <SelectSearch
                    options={campusCity}
                    placeholder="City"
                    // label="Institution Name"
                    name="institution_city"
                    value={formValues?.institution_city}
                    onChange={handleChange}
                    disabled={buttonState || disableMode}
                  />

                </div>

                <div className="col-md-6 col-12" style={{ marginBottom: '24px' }}>
                  <SelectSearch
                    options={campus}
                    placeholder="Campus"
                    // label="Campus"
                    name="campus"
                    value={formValues?.campus}
                    onChange={handleChange}
                    disabled={buttonState || disableMode}
                  />
                </div>
                {!!degrees?.length && (
                <div className="col-md-6 col-12" style={{ marginBottom: '24px' }}>
                  <SelectSearch
                    name="degree"
                    options={degrees}
                    value={formValues?.degree}
                    placeholder="Degree"
                    width="100%"
                    onChange={handleChange}
                    disabled={buttonState || disableMode}
                  />

                </div>
                )}
                {!!questions?.length && (

                <div className="col-md-6 col-12" style={{ marginBottom: '24px' }}>
                  <SelectSearch
                    options={questions}
                    name="flight_question"
                    value={formValues?.flight_question}
                    placeholder="Flight Question"
                    width="100%"
                    onChange={handleChange}
                    disabled={buttonState || disableMode}
                  />

                </div>
                )}

                {!!questions?.length && (
                <div className="col-md-6 col-12" style={{ marginBottom: '24px' }}>
                  <SelectSearch
                    options={[{ label: 'Yes', value: 'Yes' },
                      { label: 'No', value: 'No' }]}
                    name="flight_answer"
                    value={formValues?.flight_answer}
                    placeholder="Flight Answer"
                    disabled={buttonState || disableMode}
                    width="100%"
                    onChange={handleChange}
                  />
                </div>
                )}
                {formValues?.degree === 'Others' && (
                <div className="col-md-6 col-12" style={{ marginBottom: '24px' }}>
                  <TextInput
                    name="otherProgramme"
                    type="text"
                    value={formValues?.otherProgramme}
                    label="Enter Programme"
                    width="100%"
                    customOnChange={handleChange}
                    disabled={buttonState || disableMode}
                  />
                </div>
                )}
                <div className="col-md-6 col-12" style={{ marginBottom: '24px' }}>
                  <TextInput
                    name="isPGWPEligible"
                    type="text"
                    value={formValues?.isPGWPEligible}
                    label="PGWP Eligible"
                    disabled
                    width="100%"
                    customOnChange={handleChange}
                  />
                </div>

              </div>
              <div className="flexed-end">
                <div className="customer-update-btn-wrapper">
                  <StyledButton
                    name="CANCEL"
                    backgroundColor="white"
                    color="#000"
                    padding="10px 24px"
                    borderRadius="4px"
                    border="1px solid #000"
                    onClick={() => history?.goBack()}
                    disabled={updateUserProfileLoading}
                    marginRight="16px"
                    height="32px"
                    width="140px"
                    fontSize="12px"
                    fontWeight="700"
                  />
                </div>
                <div className="customer-update-btn-wrapper">
                  <StyledButton
                    name={updateUserProfileLoading ? 'Please wait...' : 'SAVE CHANGES'}
                    backgroundColor={isAllowUpdate ? 'black' : '#EFF1F3'}
                    color={isAllowUpdate ? 'white' : '#C4C4C4'}
                    padding="10px 24px"
                    borderRadius="4px"
                    border="none"
                    height="32px"
                    fontSize="12px"
                    fontWeight="700"
                    onClick={handleSubmit}
                    disabled={!allDetailsSelected || !inputChangeDetected || !isAllowUpdate}
                  />
                </div>
                {/* )} */}
              </div>
            </>
          )}

      </div>

    </div>
  );
};
export default InstitutionDetailEdit;
